import authSvc from '@efex-services/auth/authSvc';
import { RoleId } from '@efexteam/permission-manager';
import { useApiCall } from '@efexteam/use-api-call';
import { selectProfileData } from '@pages/profile/store/selectors';
import { fetchUserProfile } from '@pages/profile/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/store';

const useUpdate = ({
  status,
  role,
  naturalPersonId,
}: {
  status: boolean;
  role: RoleId;
  naturalPersonId: number;
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userProfile = useSelector(selectProfileData);

  const { enterpriseId } = userProfile?.company || {};

  const {
    data: updatedMember,
    loading,
    error,
    invoke: updateTeamMemberData,
  } = useApiCall(() => {
    if (!enterpriseId) {
      throw new Error('Enterprise ID is required');
    }
    return authSvc.updateTeamMember(enterpriseId, {
      naturalPersonId,
      roleId: role,
      status,
    });
  });

  useEffect(() => {
    if (updatedMember && !error && !loading) {
      dispatch(fetchUserProfile());
      navigate('/profile?view=team');
    }
  }, [updatedMember, error, loading, navigate, dispatch]);

  return {
    loading,
    error,
    updateTeamMemberData,
  };
};

export default useUpdate;
